import React, { useState, useEffect } from 'react';
import './Stats.css';

const Stats = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            setIsVisible(true);
          }
        });
      },
      { threshold: 0.5 }
    );

    const element = document.querySelector('.stats-content');
    if (element) observer.observe(element);

    return () => observer.disconnect();
  }, []);

  return (
    <section className="stats">
      <div className={`stats-content ${isVisible ? 'visible' : ''}`}>
        <p className="stats-text">
          <span className="stats-icon">✨</span>
          Helped 1000+ startups launching their dreams
        </p>
      </div>
    </section>
  );
};

export default Stats;
